module.exports = "<div class=\"iframe-container mt-5\" no-bounce>\n  <iframe #iframe title=\"Informes Gráficas\" [src]=\"url\"></iframe>\n</div>\n"